export const TYPE_DEFAULT = 'default';
export const TYPE_LANDING = 'landing';
export const TYPE_LOBBY = 'lobby';
export const TYPE_BROADCAST = 'broadcast';
export const TYPE_SCHEDULE = 'schedule';
export const TYPE_MEMBERS = 'members';
export const TYPE_PROGRAM = 'program';
export const TYPE_SHOP = 'shop';
export const TYPE_PROFILE = 'profile';
